export class SiteDetailsRequest {
  ERPortalPath: string;
}
